<template>
  <div>
    <q-select
      v-if="!required"
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="discipline_name"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="dataLoading"
      :options="options"
      :clearable="clearable"
      :disable="disable"
      @filter="filterFn"
      @input="$emit('changed', model)"
      v-bind="siteCFG.fields.general"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
    <q-select
      v-else
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="discipline_name"
      option-value="id"
      :emit-value="true"
      map-options
      :loading="dataLoading"
      :options="options"
      :clearable="clearable"
      @filter="filterFn"
      @input="$emit('changed', model)"
      v-bind="siteCFG.fields.general"
      required
      :disable="disable"
      :rules="[v => !!v || `Discipline is required`]"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: "Assign Discipline"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    teamOnly: {
      type: Boolean,
      default: false
    },
    excludeIds: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      data: "disciplines/list",
      teamOnlyList: "disciplines/teamOnlyList",
      dataLoading: "disciplines/listLoading"
    })
  },
  watch: {
    id: function() {
      this.init();
    },
    disciplines: function() {
      this.init();
    }
  },
  data: () => ({
    model: null,
    options: []
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let filteredData = this.teamOnly ? this.teamOnlyList : this.data;
      if (this.excludeIds.length > 0) {
        filteredData = filteredData.filter(
          d => !this.excludeIds.includes(d.id)
        );
      }
      this.options = JSON.parse(JSON.stringify(filteredData));
      this.model = this.id;
    },
    filterFn(val, update) {
      if (val === "") {
        update(() => {
          let filteredData = this.teamOnly ? this.teamOnlyList : this.data;
          if (this.excludeIds.length > 0) {
            filteredData = filteredData.filter(
              d => !this.excludeIds.includes(d.id)
            );
          }
          this.options = JSON.parse(JSON.stringify(filteredData));
        });
        return;
      } else {
        update(() => {
          const needle = val.toLowerCase();
          let data = this.teamOnly ? this.teamOnlyList : this.data;
          if (this.excludeIds.length > 0) {
            data = data.filter(d => !this.excludeIds.includes(d.id));
          }
          this.options = data.filter(
            v => v.discipline_name.toLowerCase().indexOf(needle) > -1
          );
        });
      }
    }
  }
};
</script>
